export const data = [
  {
    id: 1,
    title: 'Raport Anual de Activitate Clinică și Administrativă',
    type: 'Medical al pacientului',
    department: 'Departamente medicale'
  }
]

export const years = [
  {
    id: 1,
    year: 2024
  },
  {
    id: 2,
    year: 2023
  },
  {
    id: 3,
    year: 2022
  },
  {
    id: 4,
    year: 2021
  },
  {
    id: 5,
    year: 2020
  },
  {
    id: 6,
    year: 2019
  },
  {
    id: 7,
    year: 2018
  },
  {
    id: 8,
    year: 2017
  },
  {
    id: 9,
    year: 2016
  },
  {
    id: 10,
    year: 2015
  },
  {
    id: 11,
    year: 2014
  },
  {
    id: 12,
    year: 2013
  }
]

export type RecordType = {
  id: number
  code: string
  region: string
  people_count: number
  total_percentage: number
  age_0_14: number
  age_15_24: number
  age_25_44: number
  age_45_64: number
  age_65: number
  men: number
  women: number
}

export const tableData: RecordType[] = [
  {
    id: 1,
    code: '0100',
    region: 'Chișinău',
    people_count: 1500,
    total_percentage: 30,
    age_0_14: 300,
    age_15_24: 200,
    age_25_44: 200,
    age_45_64: 400,
    age_65: 300,
    men: 800,
    women: 600
  },
  {
    id: 2,
    code: '0200',
    region: 'Bălți',
    people_count: 400,
    total_percentage: 8,
    age_0_14: 80,
    age_15_24: 40,
    age_25_44: 40,
    age_45_64: 100,
    age_65: 100,
    men: 200,
    women: 50
  }
]
